export enum StoreId {
  APP = 'app',
  CITY = 'city',
  LOGIN = 'login',
  USER = 'user',
  BASKET = 'basket',
  ANALYTICS = 'analytics',
  BASKET_CHANGE = 'basketChange',
  SLIDERS = 'sliders',
  SIMPLE_CATEGORIES = 'simpleCategories',
  TOGGLE = 'toggle',
  PROMOCODES = 'promocodes',
  BASKET_PAYMENT_METHODS = 'basketPaymentMethods',
  BASKET_PAYMENT_CARDS = 'basketPaymentCards',
  BASKET_TIME = 'basketTime',
  ADDRESSES = 'addresses',
  POINT = 'point',
  BANNERS = 'banners',
  MAP_SETTINGS = 'mapSettings',
  BONUS_HISTORY = 'bonusHistory',
  ORDERS = 'orders',
  ORDER = 'order',
  SALES = 'sales',
  SALE = 'sale',
  DELIVERY = 'delivery',
}

export interface LoadState<T, U = Error> {
  isLoading: boolean
  data: T
  isLoaded: boolean
  error: U | null
}
